var websock = null;
let rec; //断线重连后，延迟5秒重新创建WebSocket连接  rec用来存储延迟请求的代码
let isConnect = false; //连接标识 避免重复连接
let connectCallBack = null;
let messageCallBack = null;
let closeCallBack = null;
let refreshIntervalId = null; // 定义全局变量用于存储 setInterval 返回的 ID
import vm from "../main.js";
import { url } from "../api/url.js";

// 假设你有一个函数saveMindId用于将mindId保存到本地存储
function saveMindId(mindId) {
	localStorage.setItem('mindId', mindId);
}

// 初始化mindId，可以从本地存储获取，如果没有则默认为0
// let mindId = parseInt(localStorage.getItem('mindId')) || 0;

let connect = (wsurl, accessToken) => {
	try {
		if (isConnect) {
			return;
		}
		// console.log("连接WebSocket", wsurl);
		websock = new WebSocket(wsurl);
		websock.onmessage = function (e) {
			// console.log("收到消息:", e);
			let sendInfo = JSON.parse(e.data)
			if (sendInfo.cmd == 0) {
				// heartCheck.start()
				// 登录成功才算真正完成连接
				connectCallBack && connectCallBack();
				console.log('WebSocket登录成功');
				pullOfflineMessage();
			} else if (sendInfo.cmd == 1) {
				// 重新开启心跳定时
				heartCheck.reset();
			} else {
				// 其他消息转发出去
				// console.log("收到消息:", sendInfo, sendInfo.data.id);
				// 更新mindId
				// if (sendInfo.data.id > mindId) {
				// 	mindId = sendInfo.data.id;
				// 	saveMindId(mindId); // 保存最新的mindId到本地存储
				// };
				if (sendInfo.data.type == 30) return;
				saveMindId(sendInfo.data.id); // 保存最新的mindId到本地存储
				let chatRecords = localStorage.getItem(`chatRecords${vm.user.id}`);
				if (chatRecords) {
					chatRecords = JSON.parse(chatRecords);
				} else {
					chatRecords = {};
				}

				// 确保 chatRecords[sendInfo.data.parentName] 是一个数组
				if (!chatRecords[sendInfo.data.parentName]) {
					chatRecords[sendInfo.data.parentName] = [];
				}

				chatRecords[sendInfo.data.parentName].push({
					sender: sendInfo.data.sender,
					text: sendInfo.data.content,
					parentId: sendInfo.data.parentId
				});

				localStorage.setItem(`chatRecords${vm.user.id}`, JSON.stringify(chatRecords));
				messageCallBack && messageCallBack(sendInfo.cmd, sendInfo.data);
			}
		}
		websock.onclose = function (e) {
			console.log('WebSocket连接关闭', e)
			isConnect = false; //断开后修改标识
			closeCallBack && closeCallBack(e);

			if (refreshIntervalId) {
				clearInterval(refreshIntervalId);
				refreshIntervalId = null;
				console.log("刷新TOKEN定时任务关闭");
			}
		}
		websock.onopen = function () {
			console.log("WebSocket连接成功");
			isConnect = true;
			// 发送登录命令
			let loginInfo = {
				cmd: 0,
				data: {
					accessToken: accessToken
				}
			};
			websock.send(JSON.stringify(loginInfo));
			refreshToken(); // 连接成功后先刷新一次TOKEN

			// 启动定时器 刷新accessToken
			if (!refreshIntervalId) { // 确保只设置一次定时器
				console.log("刷新TOKEN定时任务开启");

				refreshIntervalId = setInterval(() => {
					refreshToken();
				}, 20 * 60 * 1000); // 每隔20分钟执行一次
			}
		}

		// 连接发生错误的回调方法
		websock.onerror = function () {
			console.log('WebSocket连接发生错误')
			isConnect = false; //连接断开修改标识
			reconnect(wsurl, accessToken);
		}
	} catch (e) {
		console.log("尝试创建连接失败");
		reconnect(wsurl, accessToken); //如果无法连接上webSocket 那么重新连接！可能会因为服务器重新部署，或者短暂断网等导致无法创建连接
	} 
};

//定义重连函数
let reconnect = (wsurl, accessToken) => {
	console.log("尝试重新连接");
	if (isConnect) {
		//如果已经连上就不在重连了
		return;
	}
	rec && clearTimeout(rec);
	rec = setTimeout(function () { // 延迟5秒重连  避免过多次过频繁请求重连
		connect(wsurl, accessToken);
	}, 15000);
};
//设置关闭连接
let close = (code) => {
	websock && websock.close(code);
};


//心跳设置
let heartCheck = {
	timeout: 1 * 1 * 1000, //每段时间发送一次心跳包 这里设置为1分钟
	timeoutObj: null, //延时发送消息对象（启动心跳新建这个对象，收到消息后重置对象）
	start: function () {
		if (isConnect) {
			console.log('发送WebSocket心跳')
			let heartBeat = {
				cmd: 1,
				data: {}
			};
			websock.send(JSON.stringify(heartBeat))
		}
	},

	reset: function () {
		clearTimeout(this.timeoutObj);
		this.timeoutObj = setTimeout(function () {
			heartCheck.start();
		}, this.timeout);

	}
};



// 实际调用的方法
let sendMessage = (agentData) => {
	if (websock.readyState === websock.OPEN) {
		// 若是ws开启状态
		websock.send(JSON.stringify(agentData))
	} else if (websock.readyState === websock.CONNECTING) {
		// 若是 正在开启状态，则等待1s后重新调用
		setTimeout(function () {
			sendMessage(agentData)
		}, 1000)
	} else {
		// 若未开启 ，则等待1s后重新调用
		setTimeout(function () {
			sendMessage(agentData)
		}, 1000)
	}
}

function refreshToken() {
	// const refreshTokenValue = JSON.parse(window.localStorage.getItem('local_userInfo')).refreshToken;

	vm.put('/bx/sc/teacher/refreshTokenTeacher', {}).then(response => {
		// 假设响应中包含新的 accessToken
		// const newAccessToken = response.data.accessToken;
		// let userInfo = JSON.parse(window.localStorage.getItem('local_userInfo'));
		// userInfo.accessToken = newAccessToken;
		window.localStorage.setItem('local_userInfo', JSON.stringify(response.data));

		console.log("AccessToken has been refreshed.");
	}).catch(error => {
		console.error("Failed to refresh token", error);
		// 可以在这里处理错误情况，例如重新登录或提示用户
	});
}

function pullOfflineMessage() {
	// const refreshTokenValue = JSON.parse(window.localStorage.getItem('local_userInfo')).refreshToken;
	let data = {
		// classId:
		// studentId:
		minId: parseInt(localStorage.getItem('mindId')) || 0
	};

	vm.get('/bx/sc/message/pullOfflineMessage', data).then(response => {
	}).catch(error => {
	});
}

let onConnect = (callback) => {
	connectCallBack = callback;
}

let onMessage = (callback) => {
	messageCallBack = callback;
}

let onClose = (callback) => {
	closeCallBack = callback;
}
// 将方法暴露出去
export {
	connect,
	reconnect,
	close,
	sendMessage,
	onConnect,
	onMessage,
	onClose,
}
